import React from 'react'

export default function RightContent ({ children }) {
  return (
    <div className={'mtt-loan-modal__right-content'}>
      {children}
    </div>
  )
}
